// US market-operations route map (Epic MS-7a).
//
//   /ops/market    ERCOT simulator control console (ops/admin only)
//
// The role guard is enforced TWICE on purpose:
//   - `CrmShell`'s `ROUTE_ACCESS` matrix gates the `/ops/market` prefix, which
//     also hides the nav entry from roles that cannot open it; and
//   - the page itself re-checks and renders `<AccessDenied>`, so a direct URL
//     hit cannot slip past a future refactor of the shell.
//
// `scripts/check-no-orphan-routes.mjs` verifies at pre-commit that the
// `marketOpsRoutes` export below is imported AND spread in `US/src/router.tsx`.

import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const MarketOpsPage = lazy(() =>
  import('./pages/MarketOpsPage').then((m) => ({ default: m.MarketOpsPage })),
);

// MS-7b. Deliberately a SIBLING ROUTE under the same `/ops/market` prefix
// rather than a panel inside the console: it answers a different question on a
// different axis (GMO→subscriber delivery, not the REP↔market conversation),
// and the prefix means it inherits the existing `ROUTE_ACCESS` role gate for
// free instead of needing a second entry that could drift from the first.
//
// The two are presented as TABS (`components/MarketOpsViewTabs`), but the tabs
// are links between these two routes — the routes stay separate so deep-links,
// refresh and back/forward keep working, and so each view keeps its own data,
// filters and pagination. `services/marketOpsViews.service.ts` holds the tab
// targets and is tested against this table, so a tab can never point at a path
// declared below and then removed.
const OutboundLogPage = lazy(() =>
  import('./pages/OutboundLogPage').then((m) => ({ default: m.OutboundLogPage })),
);

export const marketOpsRoutes: RouteObject[] = [
  { path: '/ops/market', element: <MarketOpsPage /> },
  { path: '/ops/market/outbound', element: <OutboundLogPage /> },
];
